import { BinScatterMultiSelectCustomVizDefinition } from 'libs/end-to-end/src/custom-viz/BinScatterMultiSelectDefinition';
import React, { useEffect, useState } from 'react';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { useUser } from 'apps/sigma2-ui/src/state/user';
import { CustomViz } from 'apps/sigma2-ui/src/components/custom-viz/CustomViz';
import { BinScatterMultiSelectFullInterface } from 'apps/sigma2-ui/src/components/bin-scatter/BinScatterMultiSelectFullInterface';
import { IconChevronRightSvg } from 'apps/sigma2-ui/src/components/svg/IconChevronRight';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { useAnalytics } from 'apps/sigma2-ui/src/lib/hooks/useAnalytics';
import { MyFocusAreaDefinition } from 'libs/end-to-end/src/my-focus-area-definition';
import { MyObservation } from 'libs/end-to-end/src/my-observation';

interface FocusAreaGroupTrendsSectionProps {
  focusArea: MyFocusAreaDefinition;
  myObservation: MyObservation;
  organizationId: string;
}

export const FocusAreaGroupTrendsSection = ({
  focusArea,
  organizationId,
  myObservation,
}: FocusAreaGroupTrendsSectionProps) => {
  const language = useLanguage();

  const { userAuthenticatedApiCall } = useUser();

  const analytics = useAnalytics();

  useEffect(() => {
    analytics.trackEvent({
      eventName: 'Focus Area Page Viewed',
      eventProperties: {
        selectedFocusArea: focusArea.focusArea,
        selectedTab: 'Group Trends',
      },
    });
  }, [analytics, focusArea]);

  const multiSelectDefinition = BinScatterMultiSelectCustomVizDefinition;

  if (!myObservation || !organizationId) {
    return <></>;
  }

  return (
    <>
      <section
        className="flex flex-col gap-8 font-sans col-span-full pb-12"
        data-qa="focus-area-group-trends-section"
      >
        {multiSelectDefinition && myObservation && (
          <div>
            <CustomViz
              observation={myObservation.type}
              organizationId={organizationId}
              customVizDefinition={multiSelectDefinition}
              userAuthenticatedApiCall={userAuthenticatedApiCall}
            >
              <BinScatterMultiSelectFullInterface
                focusArea={focusArea}
                observation={myObservation.type}
                organizationId={organizationId}
                myObservation={myObservation}
              />
            </CustomViz>
          </div>
        )}
      </section>
    </>
  );
};
